import { catchError, finalize, tap } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { ControlDataExportForm } from '../../model/control-data/control-data-export-form';

@Injectable()
export class ControlDataExportFormService extends DataService<ControlDataExportForm> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, ControlDataExportForm, progressBar, 'cd-export');
  }

  download(id: string): Observable<File> {
    this.progressBar.start();
    return this.getFile(`${this.endpoint}/download/${id}`, 'document').pipe(
      catchError(error => {
        this.notification.showError(error);
        return [];
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  add(model: ControlDataExportForm, options: { notifyUser: boolean } = { notifyUser: true }): Observable<any> {
    this.progressBar.start();
    return this.client.post(this.endpoint, { companyId: model.companyId, incomeYear: model.incomeYear, comment: model.comment }).pipe(
      tap(() => {
        if (options && options.notifyUser) {
          this.notification.showSuccess();
        }
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  change(model: ControlDataExportForm, options: { notifyUser: boolean } = { notifyUser: true }): Observable<any> {
    this.progressBar.start();
    let updateModel = {
      id: model.id,
      comment: model.comment,
      files: model.files.map(f => {
        return {
          id: f.id,
          comment: f.comment,
          sentToTaxAuthority: f.sentToTaxAuthorityAt ? true : false,
        };
      }),
    };
    return this.client.put(this.endpoint, JSON.stringify(updateModel)).pipe(
      tap(() => {
        if (options && options.notifyUser) {
          this.notification.showSuccess();
        }
      }),
      finalize(() => this.progressBar.stop())
    );
  }
}
